export enum AppMessageSeverity {
	SUCCESS = "success",
	INFO = "info",
	WARNING = "warn",
	DANGER = "error",
	GREEN = "success",
	YELLOW = "warn",
	RED = "error",
	BLUE = "info",
}
